export default "__VITE_ASSET__BDys_PGM__"